import Vue from 'vue';
import Vuetify from 'vuetify';
import colors from 'vuetify/es5/util/colors';

import FoodIcon from '@we-are-ocus/ocus-components/src/assets/iconComponent/FoodIcon.vue';
import ArchitectureIcon from '@we-are-ocus/ocus-components/src/assets/iconComponent/ArchitectureIcon.vue';
import LifestyleIcon from '@we-are-ocus/ocus-components/src/assets/iconComponent/LifestyleIcon.vue';
import FashionIcon from '@we-are-ocus/ocus-components/src/assets/iconComponent/FashionIcon.vue';
import NatureIcon from '@we-are-ocus/ocus-components/src/assets/iconComponent/NatureIcon.vue';
import PortraitIcon from '@we-are-ocus/ocus-components/src/assets/iconComponent/PortraitIcon.vue';
import ProductIcon from '@we-are-ocus/ocus-components/src/assets/iconComponent/ProductIcon.vue';
import SocialIcon from '@we-are-ocus/ocus-components/src/assets/iconComponent/SocialIcon.vue';
import SportIcon from '@we-are-ocus/ocus-components/src/assets/iconComponent/SportIcon.vue';
import ActionIcon from '@we-are-ocus/ocus-components/src/assets/iconComponent/ActionIcon.vue';
import GoogleIcon from '@we-are-ocus/ocus-components/src/assets/iconComponent/GoogleIcon.vue';
import IndoorIcon from '@we-are-ocus/ocus-components/src/assets/iconComponent/IndoorIcon.vue';
import OutdoorIcon from '@we-are-ocus/ocus-components/src/assets/iconComponent/OutdoorIcon.vue';
import MapIcon from '@we-are-ocus/ocus-components/src/assets/iconComponent/MapIcon.vue';
import MatterportIcon from '@we-are-ocus/ocus-components/src/assets/iconComponent/MatterportIcon.vue';
import PeopleIcon from '@we-are-ocus/ocus-components/src/assets/iconComponent/PeopleIcon.vue';
import PhotoIcon from '@we-are-ocus/ocus-components/src/assets/iconComponent/PhotoIcon.vue';
import ServiceIcon from '@we-are-ocus/ocus-components/src/assets/iconComponent/ServiceIcon.vue';
import VideoIcon from '@we-are-ocus/ocus-components/src/assets/iconComponent/VideoIcon.vue';
import Virtual_tourIcon from '@we-are-ocus/ocus-components/src/assets/iconComponent/Virtual_tourIcon.vue';

Vue.use(Vuetify);

export default (ctx) => {
  const vuetify = new Vuetify({
    theme: {
      options: { customProperties: true },
      themes: {
        light: {
          primary: colors.blue.lighten2,
          accent: colors.grey.lighten3,
          secondary: colors.amber.lighten3,
          info: colors.teal.lighten1,
          warning: '#F2994A',
          error: '#F56C6C',
          success: '#86DC84',
          /* TEMP colors from ocus component are not available */
          lightBlue: '#E2F3FF',
          errorLight: 'FEF0F0',
          deepBlack: '#000',
          lightDark: '#323232',
          nightBlue: '#172957',
          bluebis: '#07C0C6',
          blue5percent: '#EAF6f6',
          midBlue: '#0496FF',
          emerald: '#86DC84',
          orange: '#FF5B35',
          darkOrange: '#E55126',
          lightOrange: '#FFEEEA',
          midOrange: '#F2994A',
          red: '#EB5757',
          redOrange: '#FF9B93',
          yellow: '#FFCC00',
          darkGrey: '#2C2C2C',
          midGrey: '#262729',
          grey: '#8C8C8C',
          lightGrey: '#C4C4C4',
          lighterGrey: '#F7F9F9',
          greyBlue: '#7C84A4',
          lightGreyBlue: '#F0F1F8',
          black: '#262729',
          white: '#FFFFFF',
          alertError: '#FF9B93',
          alertSuccess: '#86DC84',
          lightGreen: '#e2f1ea',
          darkGreen: '#2fa666',
          lightRed: '#fef0f0',
          deepBlue: '#4E92B9',
          roseAlert: '#F56C6C',
          accentRed: '#FF5A2A',
          accentBlue: '#00C1C8',
          accentGray: '#4F4F4F',
          accentYellow: '#FFCD00',
          accentDark: '#212120',
          avatarBlue: '#5A83ED',
          unableGray: '#E0E0E0',
          availableBlue: '#56CCF2',
          blue: '#07C0C6',
          darkerGrey: '#6F7073',
          stepGrey: '#5F6368',
          predictionDark: '#333333',
          predictionDivider: '#F2F2F2',
          predictionGrey: '#828282',
          rejectedRed: '#F56C6D',
          iconGrey: '#7A7A7A',
          skillOverlay: '#F1F8FF',
          skillOverlayDeclined: '#FEF0F0',
        },
      },
    },
    icons: {
      values: {
        FoodIcon: {
          component: FoodIcon,
        },
        ArchitectureIcon: {
          component: ArchitectureIcon,
        },
        LifestyleIcon: {
          component: LifestyleIcon,
        },
        FashionIcon: {
          component: FashionIcon,
        },
        PortraitIcon: {
          component: PortraitIcon,
        },
        ProductIcon: {
          component: ProductIcon,
        },
        SocialIcon: {
          component: SocialIcon,
        },
        SportIcon: {
          component: SportIcon,
        },
        NatureIcon: {
          component: NatureIcon,
        },
        ActionIcon: {
          component: ActionIcon,
        },
        GoogleIcon: {
          component: GoogleIcon,
        },
        IndoorIcon: {
          component: IndoorIcon,
        },
        OutdoorIcon: {
          component: OutdoorIcon,
        },
        MapIcon: {
          component: MapIcon,
        },
        MatterportIcon: {
          component: MatterportIcon,
        },
        PeopleIcon: {
          component: PeopleIcon,
        },
        PhotoIcon: {
          component: PhotoIcon,
        },
        ServiceIcon: {
          component: ServiceIcon,
        },
        VideoIcon: {
          component: VideoIcon,
        },
        Virtual_tourIcon: {
          component: Virtual_tourIcon,
        },
      },
    },
  });

  ctx.app.vuetify = vuetify;
  ctx.$vuetify = vuetify.framework;
};
